"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
require("./styles/skeleton-form.scss");
/**
 * Form skeleton with multiple shimmer fields
 */
var SkeletonForm = function (_a) {
    var _b = _a.fields, fields = _b === void 0 ? 3 : _b, className = _a.className;
    return (react_1.default.createElement("div", { className: "skeleton-form " + (className || "") },
        Array.from({ length: fields }).map(function (_, index) { return (react_1.default.createElement("div", { key: index, className: "skeleton-form-field" },
            react_1.default.createElement(office_ui_fabric_react_1.Shimmer, { width: "30%" }),
            react_1.default.createElement("br", null),
            react_1.default.createElement(office_ui_fabric_react_1.Shimmer, null),
            react_1.default.createElement("br", null),
            react_1.default.createElement("br", null))); }),
        react_1.default.createElement("div", { className: "skeleton-form-actions" },
            react_1.default.createElement(office_ui_fabric_react_1.Shimmer, { width: "100px" }),
            react_1.default.createElement(office_ui_fabric_react_1.Shimmer, { width: "100px", style: { marginLeft: "10px" } }))));
};
exports.default = SkeletonForm;
